"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productBasedOfferIdsWithMandatoryMerchSelector = exports.productBasedOfferDiscountSelector = exports.productBasedOfferIdSelector = void 0;

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _RequiredOnboardingSelectors = require("pricing-pages-unified-ui/selectors/RequiredOnboardingSelectors");

var productBasedOfferIdSelector = function productBasedOfferIdSelector(state, merchId) {
  var merchSpecificPromotion = (0, _PromotionSelectors.merchSpecficPromotionEligibilitySelector)(state, merchId);
  if (!merchSpecificPromotion || !merchSpecificPromotion.productOfferId) return null;
  return merchSpecificPromotion.productOfferId;
};

exports.productBasedOfferIdSelector = productBasedOfferIdSelector;

var productBasedOfferDiscountSelector = function productBasedOfferDiscountSelector(state, merchId) {
  var merchSpecificPromotion = (0, _PromotionSelectors.merchSpecficPromotionEligibilitySelector)(state, merchId);
  if (!merchSpecificPromotion || !merchSpecificPromotion.productOfferId) return null;
  return merchSpecificPromotion.productDiscount;
};

exports.productBasedOfferDiscountSelector = productBasedOfferDiscountSelector;

var productBasedOfferIdsWithMandatoryMerchSelector = function productBasedOfferIdsWithMandatoryMerchSelector(state) {
  var promotions = [];

  for (var _len = arguments.length, merchIds = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    merchIds[_key - 1] = arguments[_key];
  }

  merchIds.forEach(function (merchId) {
    var onboardingMerchId = (0, _RequiredOnboardingSelectors.requiredOnboardingMerchIdSelector)(state, merchId);
    var merchOfferId = productBasedOfferIdSelector(state, merchId);

    if (merchOfferId) {
      promotions.push(merchOfferId);
    }

    if (onboardingMerchId) {
      var onboardingOfferId = productBasedOfferIdSelector(state, onboardingMerchId);
      if (onboardingOfferId) promotions.push(onboardingOfferId);
    }
  });
  return promotions;
};

exports.productBasedOfferIdsWithMandatoryMerchSelector = productBasedOfferIdsWithMandatoryMerchSelector;